import store from '../store/index'

export default class ProfessionalService {
    async getProfessionals() {
        const data = await store.dispatch('jv/get', ['staff-professionals', {params: {include: 'staff,professional'}}]);
        return Object.values(data)
    }

    async createProfessional(payload) {
        return await store.dispatch('jv/post', payload)
    }

    async updateProfessional(payload) {
        return await store.dispatch('jv/patch', payload)
    }

    async deleteProfessional(id) {
        return await store.dispatch('jv/delete', `staff-professionals/${id}`)
    }

    async getProfessionalFromTitle(title) {
        return await store.dispatch('jv/get', ['professionals', {params: {'filter[title][eq]': title}}]);
    }

    logError(e) {
        const error = []
        if (e.response.data.errors) {
            // Work with each error from the JSONAPI 'errors' array
            for (const err of e.response.data.errors) {
                error.push(err.detail)
            }
        }
        return error
    }

    async fetchAvailableTitles(){
        const $dispatchResult = await store.dispatch('jv/get', ['professionals', {params: {'fields[professionals]': 'title'}}]);
        const $array = await Object.entries($dispatchResult).map(a => a[1].title);
        await $array.push($array.splice($array.indexOf('Others'), 1).pop());
        return $array.map(element => {
            const container = {};
            container["name"] = element;
            return container;
        });
    }

    async fetchAvailableFullTitles(){
        const $dispatchResult = await store.dispatch('jv/get', ['professionals', {params: {'fields[professionals]': 'description'}}]);
        const $array = await Object.entries($dispatchResult).map(a => a[1].description).filter((v, i, a) => a.indexOf(v) === i);
        return $array.map(element => {
            const container = {};
            container["name"] = element;
            return container;
        });
    }

    async fetchAvailableInstitutions(){
        const $dispatchResult = await store.dispatch('jv/get', ['professionals', {params: {'fields[professionals]': 'institution'}}]);
        const $array = await Object.entries($dispatchResult).map(a => a[1].institution).filter((v, i, a) => a.indexOf(v) === i);
        return $array.map(element => {
            const container = {};
            container["name"] = element;
            return container;
        });
    }
}
